<template>
  <v-app :dark="isDark">

    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      :class="{'mt-5': breakpoint.lg === true || breakpoint.xl === true}"
    >
      <v-list v-if="isLoggedIn" >
        <v-list-tile 
          v-for="(item, i) in items"
          :key="i"
          :to="{path: '/' + item.route}"
          :class="{'dark-link': isDark}"
          :active-class="isDark ? 'active-menu-link-dark' : 'active-menu-link-light'"
        >
          <v-list-tile-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list v-else>
        <v-list-tile :to="{path: '/signin'}">
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sign In</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      dense
      :clipped-left="clipped"
      class="nav-toolbar"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon @click="isDark = !isDark">invert_colors</v-icon>
      </v-btn>
      <v-menu v-if="isLoggedIn" bottom left>
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="onLogout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    
    <v-content>
      <div class="main-content" :style="{maxHeight: eventsHeight}">
      <v-container fluid fill-height>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
      </v-container>
      </div>
    </v-content>

    <v-footer v-if="isLoggedIn" app height="auto" class="events">
      <v-card class="flex elevation-10" tile>
        <v-card-title @click="toggleEvents" class="pl-3 pr-0 pb-1 pt-1 footer-bar pointer" style="max-height:41px;margin-top:-5px;">
          <span v-if="!ui.events"> 
            <v-chip small label :color="latestEvent.type" text-color="white">{{latestEvent.type.toUpperCase()}}</v-chip> 
            <span class="ml-1 event-subtext">{{latestEvent.event}}</span>
          </span>
          <span v-if="ui.events" class="ml-1" style="font-size:14px!important;">
            <v-icon small style="font-size:16px!important;">message</v-icon>
           Events
          </span>
          <v-spacer></v-spacer>
          <span v-if="!ui.events">
            <span style="position:relative;padding-top:2px;">{{latestEvent.user}} {{latestEvent.timestamp}}</span>
          </span>
          <v-btn small icon>
            <v-icon v-if="ui.events">keyboard_arrow_down</v-icon>
            <v-icon v-else>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-card-title>

        <transition name="fadeHeight" mode="in-out">
        <v-card-text v-show="ui.events" id="event-box" class="pa-0 pl-3 pr-3 pt-2" style="max-height:175px;height:175px!important;overflow:overlay!important;" v-chat-scroll="{always: false, smooth: true}">
          <v-card flex flat class="pa-0">
          <v-card-title v-for="(event,i) in events" :key="'event-'+i" class="event-text">
            <v-chip small label :color="event.type" text-color="white">{{event.type.toUpperCase()}}</v-chip> 
            <span class="ml-1">{{event.event}}</span>
            <v-spacer></v-spacer>
            {{event.user ? event.user + ' ·' : ''}} {{event.timestamp}}
          </v-card-title>
          </v-card>
        </v-card-text>
        </transition>
        

      </v-card>
    </v-footer>

  </v-app>
</template>

<script>
import {auth, db, functions} from '@/services/firebase.js'
import moment from 'moment'

export default {
  name: 'App',
  data () {
    return {
      ui: {
        snackbar: false,
        snackbar_color: 'info',
        snackbar_text: '',
        menu_open: false,
        events: false,
        eventsHeight: 34
      },
      isDark: false,
      clipped: true,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'insert_chart_outlined',
          title: 'Dashboard',
          route: 'dashboard'
        },
        {
          icon: 'view_comfy',
          title: 'Boxes',
          route: 'boxes'
        },
        {
          icon: 'store',
          title: 'Products',
          route: 'products'
        },
        {
          icon: 'contact_mail',
          title: 'Drafts',
          route: 'drafts'
        },
        {
          icon: 'insert_emoticon',
          title: 'Subscriptions',
          route: 'subscriptions'
        },
        {
          icon: 'local_shipping',
          title: 'Trackers',
          route: 'trackers'
        },
        {
          icon: 'print',
          title: 'Shipments',
          route: 'shipments'
        },
        {
          icon: 'refresh',
          title: 'Returns',
          route: 'returns'
        },
        {
          icon: 'email',
          title: 'Email',
          route: 'email'
        },
        {
          icon: 'table_chart',
          title: 'Analytics',
          route: 'analytics'
        },
        {
          icon: 'attach_money',
          title: 'Billing',
          route: 'billing'
        },
        {
          icon: 'group',
          title: 'Users',
          route: 'users'
        },
        {
          icon: 'settings',
          title: 'Settings',
          route: 'settings'
        }
      ],
      miniVariant: false,
      title: 'WaltBox',
      events: []
    }
  },
  watch: {
    'isDark': function (newTheme) {
      var self = this
      self.$root.$emit('is-dark', newTheme)
      self.saveUserSettings({darkTheme: newTheme})
    }
  },
  computed: {
      isLoggedIn () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      eventsHeight: function () {
        var self = this
        if(self.ui.events){
          return window.innerHeight - 257 + 'px'
        } else {
          return window.innerHeight - 84 + 'px'
        }
      },
      latestEvent: function () {
        var self = this
        if(self.events.length >= 1){
          return self.events[self.events.length - 1]
        } else {
          return {type: 'info', event: 'No events lately', timetamp: moment().format('M/D/YY, h:mm:ss A')}
        }
      },
      breakpoint: function () {
        return this.$vuetify.breakpoint
      }
  },
  created () {
    var self = this
    /*
    const feed = self.$feeds.feed('subscription')
    feed.subscribe({
      previousItems: 500,
      onOpen: () => {},
      onItem: (event) => {
        if(self.events.length >= 500){
          self.events.shift()
        }
        event.data.timestamp = moment.unix(event.created).format('M/D/YY, h:mm:ss A')
        self.events.push(event.data)
        var eventWindow = document.getElementById('event-box')
        var isScrolled = (eventWindow.scrollTop < eventWindow.scrollHeight - eventWindow.offsetHeight - 10)

        self.$nextTick(() => {
          if (!isScrolled) {
            eventWindow.scrollTop = eventWindow.scrollHeight
          }
        })
      },
      onError: (error) => {
        console.error(error)
      }
    })
    */

    self.$root.$on('event', (event) => {
      var pusherEvent = functions.httpsCallable('pusherEvent')
      pusherEvent({type: event.type, event: event.event, user: self.$store.getters.user.email})
      .then(() => {})
      .catch((err) => {
        console.error(err)
      })
    })

    self.$root.$on('notify', (options) => {
      self.ui.snackbar_text = options.text
      self.ui.snackbar_color = options.color
      self.ui.snackbar = true
    })

    if(self.isLoggedIn){
      db.collection('users').doc(self.$store.getters.user.id).onSnapshot(user => {
        user = user.data()
        this.$store.dispatch('setUserAccess', user.access)
        // keep our user access token updated
        auth.currentUser.getIdToken(true)

        self.isDark = user.darkTheme
      })
      db.collection('settings').doc('events').onSnapshot(events => {
        events = events.data()
        
        if(self.events.length >= 500){
          self.events.shift()
        }
        let eventsUpdate = []
        events.events.forEach((event) => {
          event.timestamp = moment(event.created).format('M/D/YY, h:mm:ss A')
          eventsUpdate.push(event)
        })
        self.events = eventsUpdate
        var eventWindow = document.getElementById('event-box')
        var isScrolled = (eventWindow.scrollTop < eventWindow.scrollHeight - eventWindow.offsetHeight - 10)

        self.$nextTick(() => {
          if (!isScrolled) {
            eventWindow.scrollTop = eventWindow.scrollHeight
          }
        })
      })
    }
  },
  methods: {
      go: function (route) {
        var self = this
        self.drawer = false
        self.$router.push({name: route})
      },
      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/')
      },
      onScroll: function (e) {
        this.ui.offsetTop = e.target.scrollTop
      },
      toggleEvents: function () {
        var self = this
        self.ui.events = !self.ui.events
        var eventWindow = document.getElementById('event-box')
        var isScrolled = (eventWindow.scrollTop < eventWindow.scrollHeight - eventWindow.offsetHeight - 10)

        self.$nextTick(() => {
          if (!isScrolled) {
            eventWindow.scrollTop = eventWindow.scrollHeight
          }
        })
      },
      saveUserSettings (update) {
        var self = this
        db.collection('users').doc(self.$store.getters.user.id).update(update)
      }
  },
  mounted () {
    
  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono:300,400')
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400')
html
  overflow hidden!important
.application
  font-family 'Open Sans'!important
.main-content
  overflow-y overlay!important
  backface-visibility hidden
  max-height calc(100vh - 90px)
.theme--dark .main-content::-webkit-scrollbar, .theme--dark .events .v-card__text::-webkit-scrollbar
  background #212121!important
  width 7px!important
.theme--dark .main-content::-webkit-scrollbar-thumb, .theme--dark .events .v-card__text::-webkit-scrollbar-thumb
  background #212121!important
  border-radius 0px!important
  width 7px!important
.theme--dark .main-content::-webkit-scrollbar-track-piece, .theme--dark .events .v-card__text::-webkit-scrollbar-track-piece
  background rgb(48, 48, 48)!important
.theme--light .main-content::-webkit-scrollbar, .theme--light .events .v-card__text::-webkit-scrollbar
  background #1976d2!important
  width 7px!important
.theme--light .main-content::-webkit-scrollbar-thumb, .theme--light .events .v-card__text::-webkit-scrollbar-thumb
  background #1976d2!important
  border-radius 0px!important
  width 7px!important
.theme--light .main-content::-webkit-scrollbar-track-piece, .theme--light .events .v-card__text::-webkit-scrollbar-track-piece
  background #FAFAFA!important
.active-menu-link-light
  background #1976d2!important
  color #FFFFFF!important
.active-menu-link-dark
  background #212121!important
  color #FFFFFF!important
.dark-link
  color white!important
.pointer
  cursor pointer
.mt-30
  margin-top 30px
.mb-30
  margin-bottom 30px
.mt-20
  margin-top 20px
.mb-20
  margin-bottom 20px
.mt-10
  margin-top 10px
.mb-10
  margin-bottom 10px
.w-100
  width 100%
.md-dialog
  width 90%
  height 90%
  max-height 100%
  max-width 100%
.theme--dark-old .variant-table table
    background #0D2029!important
    background-color #0D2029!important
table tbody tr:not(:last-child)
    border-bottom 0px!important
.v-datatable table .v-table thead th
  font-size 12px!important
table.v-table tbody td, table.v-table tbody th, table.v-table thead th, table.v-table thead tr, table.v-table tbody tr
  max-height 35px!important
  font-size 14px!important
.theme--dark-old table tr:hover
  background-color #5A6D76!important
.events
  font-size 10px!important
  font-family 'Roboto Mono'!important
  .event-text
    padding 0px
  .v-chip--small
    height 16px!important
  .v-chip__content
    padding 2px
    font-size 10px!important
.theme--dark-old .events
  color rgb(255, 255, 255, 0.75)!important
.theme--dark-old .events .v-card
  background #1d2935!important
  .footer-bar
    background #0D2029!important
.application.theme--dark-old, .theme--dark-old .v-navigation-drawer
  background #1d2935!important
  .v-list
    background #1d2935!important
  .v-list__tile--active
    color rgb(255, 255, 255, 0.75)!important
    background #5A6D76!important
.theme--dark-old .v-toolbar
  background #0D2029!important
.theme--dark-old .v-datatable
  background #40525B!important
.theme--dark-old button.primary
  background-color #5A6D76!important
  border-color #5A6D76!important
.theme--dark-old .v-list
  background #0d2029 !important

.theme--light.v-toolbar.nav-toolbar
  background-color #FFFFFF!important
.theme--light .variant-table table
  background #1976d2!important
  background-color #1976d2!important
  color #FFFFFF!important
.theme--light .variant-table table tr:hover
  background-color #1976d296!important
.theme--light .variant-table table tr .v-btn--icon, .theme--light .variant-table table thead th
  color #FFFFFF!important

.theme--dark .variant-table table
  background #212121!important
  background-color #212121!important

.fadeHeight-enter-active, .fadeHeight-leave-active
  transition all 1s
  max-height 209px
.fadeHeight-enter, .fadeHeight-leave-to
  transition all 0.1s
  opacity 0
  max-height 0px

.event-subtext
  position absolute!important
  padding-top 5px!important
</style>
